module.exports = __webpack_public_path__ + "img/diapositiva-8-2.69bebfcf.png";